import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import { InfoBox, SuccessBox } from '../..'
import { WidgetProps } from '../../widget.types'
import { WidgetTheme } from '../../WidgetTheme'
import { ActionButton, WidgetBox, WidgetContainer } from '../../widget.styles'

import { useThemeConfig } from '../../hooks/useThemeConfig'
import { useGetPromotionConfig } from './hooks/useGetPromotionConfig'

import { ActionButtons } from './ActionButtons'
import * as Styles from './styles'
import GetPromotionImage from './assets/ilustration.png'
import GetPromotionMobileImage from './assets/ilustration-mobile.png'

export const GetPromotion = ({ service }: WidgetProps) => {
  const { isPhone } = useMediaQueries()
  const theme = useThemeConfig({ service })
  const { text, status, steps } = useGetPromotionConfig(service)

  console.log('status', status)

  const isCompleted = status === 'completed'
  const src = isPhone ? GetPromotionMobileImage : GetPromotionImage

  const onComplete = () => {
    trackInternalEvent('progress_score_completed', { score: service.title })
  }

  useEffect(() => {
    if (isCompleted) {
      trackInternalEvent('progress_score_completed', { score: service.title })
    }
  }, [isCompleted, service.title])

  return (
    <WidgetTheme theme={theme[status]} tipOrder={service.widgetTipOrder}>
      <WidgetContainer>
        <WidgetBox>
          <InfoBox
            text={text}
            isCompleted={isCompleted}
            data-testid={`get-promotion-info-${status}`}
          >
            {isCompleted ? (
              <ActionButton
                as={Link}
                to={service.getNextActionUrl()}
                onClick={onComplete}
                data-testid="get-promotion-action-button-completed"
              >
                {text.actionText}
              </ActionButton>
            ) : (
              <ActionButtons text={text} steps={steps} status={status} service={service} />
            )}
          </InfoBox>
        </WidgetBox>
        <WidgetBox>
          {isCompleted ? (
            <SuccessBox data-testid="dashboard-widget-success-box" />
          ) : (
            <Styles.Image
              src={src}
              alt="Get Promotion"
              data-testid={isPhone ? 'get-promotion-mobile-image' : `get-promotion-image-${status}`}
            />
          )}
        </WidgetBox>
      </WidgetContainer>
    </WidgetTheme>
  )
}
